module.exports = __webpack_public_path__ + "img/prod-kitchen.8e5967cd.jpg";